import {
  ITooltipComp,
  ITooltipParams,
  PopupComponent,
} from '@ag-grid-community/core'

export class ErrorTooltipComponent
  extends PopupComponent
  implements ITooltipComp
{
  constructor() {
    super(`<div class="ag-grid-tooltip tooltip show bs-tooltip-bottom">
    <div class="arrow"></div>
    <div class="tooltip-inner"></div>
</div>`)
  }

  static generateHTML(errorMessageMap: Map<string, string[]>) {
    const html = []
    if (errorMessageMap.size > 0) {
      html.push(`<table
       style="border: 0.0625rem solid #adb5bd;"
    >
      <thead style="border-bottom:0.1875rem solid grey;background-color:#e9ecef">
        <tr>
          <th scope="col" style="border-right: 0.0625rem solid; padding-left:0.25rem">Field</th>
          <th scope="col" style="border-right: 0.0625rem solid; padding-left:0.25rem">ValidationErrors</th>
        </tr>
      </thead>
      <tbody>`)
    }
    errorMessageMap.forEach((errorMessages: string[], field: string) => {
      html.push(`<tr style="border-bottom:0.1275rem solid grey">
      <td style="border-right: 0.0625rem solid; padding-left:0.25rem">${field}</td>
      <td style="border-right: 0.0625rem solid; padding-left:0.25rem">${errorMessages.join(
        ' | ',
      )}</td>
    </tr>`)
    })

    if (errorMessageMap.size > 0) {
      html.push(` </tbody>
      </table>`)
    }

    return html
  }

  private createHtml(params: ITooltipParams) {
    const errorMap = params.node?.data.errorMessageMap as Map<string, string[]>
    return ErrorTooltipComponent.generateHTML(errorMap)
  }

  init(params: ITooltipParams) {
    this.setVisible(false)
    const html = this.createHtml(params)
    const body = this.getBody()
    if (html.length > 0 && body) {
      body.innerHTML = html.join('').trim()
      this.setVisible(true)
    }
  }

  getBody() {
    return this.getGui().querySelector<HTMLDivElement>('.tooltip-inner')
  }
}
